export const titleMapping: Record<string, string> = {
  Channel: 'Channel',
  Mouthbar: 'Mouthbar',
  Indicator: 'Indicator',
  NetToGross: 'Net-to-gross',
  ContiniousParameter: 'Continious parameter',
  ObjectEstimation: 'Object Estimation',
};
